import { createBrowserRouter } from "react-router-dom";
import AboutMe from "../Home Page/AboutMe";
import Blog from "../Home Page/Blog";
import Contact from "../Home Page/Contact";
import Home from "../Home Page/Home";
import Project1 from "../Home Page/Project1";
import Project2 from "../Home Page/Project2";
import Project3 from '../Home Page/Project3';
import Projects from "../Home Page/Projects";
import ErrorPage from "../Shared/ErrorPage";
import Root from './Root';

export const router = createBrowserRouter([
    {
        path: '/',
        element: <Root></Root>,
        errorElement: <ErrorPage></ErrorPage>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path: '/about',
                element: <AboutMe></AboutMe>
            },
            {
                path: '/contact',
                element: <Contact></Contact>
            },
            {
                path: '/blog',
                element: <Blog></Blog>
            },
            {
                path: '/project',
                element: <Projects></Projects>
            },
            {
                path: '/project1',
                element: <Project1></Project1>
            },
            {
                path: '/project2',
                element: <Project2></Project2>
            },
            {
                path: "/project3",
                element: <Project3></Project3>
            }
        ]
    }
])